// eslint-disable-next-line lumapps/do-not-import-react-redux
import { useDispatch as ReduxUseDispatch } from 'react-redux';
// eslint-disable-next-line lumapps/do-not-import-redux
import { Dispatch } from 'redux';

export * from 'react-redux';

export const useDispatch = () => ReduxUseDispatch<Dispatch<any>>();
